let morph = {
  init: function () {
    this.appHeight();
    this.toggler();
    this.wowo();
    this.slider();
    this.nav();
  },
  wowo: function () {
    let wTop = $(window).scrollTop(),
      wHeight = $(window).height(),
      wBottom = wTop + wHeight;
    $(".wowo:not(.animated)").each(function () {
      let me = $(this),
        meTop = me.offset().top,
        meHeight = me.innerHeight(),
        meBottom = meTop + meHeight,
        limitTop = wTop - meHeight,
        limitBottom = wBottom + meHeight;
      if (meTop > limitTop && meBottom < limitBottom) {
        me.addClass("animated");
        setTimeout(function () {
          me.removeClass("wowo animated");
        }, 1500);
      }
    });
  },
  nav: function () {
    if (navigator.userAgent.match(/Trident\/7\./)) {
      document.body.addEventListener &&
        document.body.addEventListener("mousewheel", function () {
          event.preventDefault();
          let wd = event.wheelDelta;
          let csp = window.pageYOffset;
          window.scrollTo(0, csp - wd);
        });
    }
    let sh = $(window).scrollTop();
    if (sh > $(".top-banner-new").outerHeight() && !$("header.navbar").hasClass("scroll-start")) {
      $('header.navbar').addClass('scroll-start');
    } else if (sh <= $(".top-banner-new").outerHeight() && $("header.navbar").hasClass("scroll-start")) {
      $('header.navbar').removeClass('scroll-start');
    }
  },
  toggler: function () {
    $(".hamburger").on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      if (!$(this).hasClass("open")) {
        $(this).addClass("open");
        $('.mobile-menu').addClass('show');
        $("body").addClass("overflow-hidden");
      } else {
        $(this).removeClass("open");
        $('.mobile-menu').removeClass('show');
        $("body").removeClass("overflow-hidden");
      }
    });

    $(".mobile-menu .close-btn button").on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      $('header .hamburger').removeClass('open');
      $('.mobile-menu').removeClass('show');
      $("body").removeClass("overflow-hidden");
    });

    $(document).on("click", (e) => {
      if (!$(e.target).closest('.mobile-menu').length && $('header .hamburger').hasClass('open')) {
        $('header .hamburger').removeClass('open');
        $('.mobile-menu').removeClass('show');
        $("body").removeClass("overflow-hidden");
      }
    })



    // view
    if ($(".announcement-bar .view-link").length > 0) {
      $(".announcement-bar .view-link").on("click", function (e) {
        e.preventDefault();
        e.stopPropagation();

        if (!$(this).hasClass("active")) {
          $("body").addClass("overflow-hidden");
        } else {
          $("body").removeClass("overflow-hidden");
        }

        $(this).toggleClass("active");
      });

      $(document).on("click", (e) => {
        if (!$(e.target).closest('.left-box').length && $('.announcement-bar .view-link').hasClass('active')) {
          $('.announcement-bar .view-link').removeClass('active');
          $("body").removeClass("overflow-hidden");
        }
      })
    }




    // submenu
    if ($("header .nav-and-reviews").length > 0) {
      function setWidth() {
        $("header .nav-and-reviews .main-menu li:not(:last-child)").each(function () {
          const me = $(this);
          me.removeAttr('style');
          me.width(me.width() + 4);
        });
      }

      setTimeout(() => {
        setWidth();
      }, 10)
      $(window).on("resize", function () {
        setWidth();
      });


      const navDom = $('header .nav-and-reviews .nav').clone();
      $('header .desktop-menu').append(navDom);

      $(".desktop-menu .sub-menu .child-nav").each(function () {
        $(this).find(".child-nav-item").eq(0).addClass("active");
      })
      $(".desktop-menu .sub-menu .product-container").each(function () {
        $(this).find(".product-item-wrapper").eq(0).addClass("active");
      })






      // function lockScroll() {
      //   const scrollTop = $(window).scrollTop();
      //   $('body').data('scrollTop', scrollTop)
      //     .data('lockSource', 'menu');
      //   $('body').css({
      //     'position': 'fixed',
      //     'top': `-${scrollTop}px`,
      //     'width': '100%'
      //   });
      // }

      // function unlockScroll() {
      //   if ($('body').css('position') === 'fixed' && $('body').data('lockSource') === 'menu') {
      //     const scrollTop = $('body').data('scrollTop') || 0;
      //     $('body').css({
      //       'position': '',
      //       'top': '',
      //       'width': ''
      //     }).removeData('lockSource');
      //     $(window).scrollTop(scrollTop);
      //   }
      // }

      $("body").on("mouseenter", ".nav-and-reviews nav>.main-menu>li", function (e) {
        e.stopPropagation();
        const $me = $(this);
        const $menuItem = $("header .desktop-menu nav>.main-menu>li");
        const $desktopMenu = $("header .desktop-menu");

        if (!$me.hasClass('active')) {
          $me.siblings('li').removeClass('active');
          $me.addClass('active');

          if (!$me.hasClass('menu-item-has-children')) {
            $desktopMenu.removeClass('show');
            // unlockScroll();
            $("body").removeClass("overflow-hidden");
            return;
          }

          $menuItem.removeClass('active');
          const index = $me.index();
          $menuItem.eq(index).addClass('active');

          if (!$desktopMenu.hasClass('show')) {
            $desktopMenu.addClass('show');
            // lockScroll();
            $("body").addClass("overflow-hidden");
          }
        }
      });

      $("body").on("mouseleave", "header", function (e) {
        e.stopPropagation();
        const $me = $(this);
        const $desktopMenu = $me.find('.desktop-menu');

        $me.find('.nav-and-reviews nav>.main-menu>li').removeClass('active');

        if ($desktopMenu.hasClass('show')) {
          $desktopMenu.removeClass('show');
          $("body").removeClass("overflow-hidden");
        }

        // unlockScroll();
      });

      $("body").on("mouseenter", "header .header-row, header .announcement-bar", function (e) {
        e.stopPropagation();
        const $me = $(this).parents('header');
        const $desktopMenu = $me.find('.desktop-menu');

        $me.find('.nav-and-reviews nav>.main-menu>li').removeClass('active');

        if ($desktopMenu.hasClass('show')) {
          $desktopMenu.removeClass('show');
          $("body").removeClass("overflow-hidden");
        }

        // unlockScroll();
      });


      // $("body").on("click", ".nav-and-reviews nav>.main-menu>li .menu-link", function (e) {
      //   e.preventDefault();
      // })



      $("body").on("mouseenter", ".desktop-menu .sub-menu .child-nav .child-nav-item a", function (e) {
        e.stopPropagation();

        const me = $(this);
        const productItem = me.parents('.sub-menu').find('.product-container .product-item-wrapper');

        if (!me.hasClass('active')) {
          me.parents('.child-nav-item').siblings('').removeClass('active');
          me.parents('.child-nav-item').addClass('active');

          productItem.removeClass('active');
          const index = me.parents('.child-nav-item').index();
          productItem.eq(index).addClass('active');
        }
      });
    }


    // mobile menu
    if ($(".mobile-menu").length > 0) {
      $("body").on("click", ".mobile-menu nav .main-menu .menu-item-has-children .menu-item-link-arrow", function (e) {
        // e.preventDefault();
        e.stopPropagation();

        const me = $(this);
        const menuItem = me.parents('.menu-item-has-children');

        if (!me.hasClass('active')) {
          menuItem.siblings('li').find('.menu-item-link-arrow').removeClass('active');
          menuItem.siblings('li').find('.sub-menu').stop().slideUp(300);

          me.addClass('active');
          menuItem.find('.sub-menu').stop().slideDown(300);
        } else {
          me.removeClass('active');
          menuItem.find('.sub-menu').stop().slideUp(300);
        }
      })

      $("body").on("click", ".mobile-menu nav .main-menu .menu-item-has-children .menu-item-link-arrow a", function (e) {
        e.stopPropagation();
      })

      $(document).on("click", function (e) {
        if (!$(e.target).closest('.mobile-menu nav .main-menu>li').length && $('.mobile-menu nav .main-menu .menu-item-has-children .menu-item-link-arrow').hasClass('active')) {
          $('.mobile-menu nav .main-menu .menu-item-has-children .menu-item-link-arrow').removeClass('active');
          $('.mobile-menu nav .main-menu .menu-item-has-children .sub-menu').stop().slideUp(300);
        }
      })


      $(".mobile-menu .sub-menu .child-nav").each(function () {
        $(this).find(".child-nav-item").eq(0).addClass("active");
      })
      $(".mobile-menu .sub-menu .product-container").each(function () {
        $(this).find(".product-item-wrapper").eq(0).addClass("active");
      })
      $("body").on("click", ".mobile-menu nav .main-menu>li .sub-menu .child-nav .child-nav-item", function (e) {
        // e.preventDefault();
        e.stopPropagation();

        const me = $(this);
        const productItem = me.parents('.sub-menu').find('.product-container .product-item-wrapper');

        if (!me.hasClass('active')) {
          me.siblings('').removeClass('active');
          me.addClass('active');

          productItem.removeClass('active');
          const index = me.index();
          productItem.eq(index).addClass('active');
        } else {
          // me.removeClass('active');
          // productItem.removeClass('active');
          return;
        }
      })


      $("body").on("click", ".mobile-menu nav .main-menu>li .sub-menu .child-nav .child-nav-item a", function (e) {
        e.stopPropagation();
      })


      $(window).on("resize", function () {
        if ($(window).width() > 1079.8) {
          if ($(".mobile-menu").hasClass('show')) {
            $(".mobile-menu").removeClass('show');
            $("header .hamburger").removeClass('open');
            $("body").removeClass("overflow-hidden");
          }
        }
      })
    }




    // video
    if ($(".testimonial-cards-box .media video").length > 0) {
      $(".testimonial-cards-box .media .video-control").on("click", function (e) {
        e.stopPropagation();

        const me = $(this);
        const video = me.parents('.media').find('video')[0];
        if (video.paused) {
          video.play();
        } else {
          video.pause();
        }
        me.toggleClass("playing");
      });

      $(".testimonial-cards-box .media video").on("ended", function () {
        const video = $(this);
        const control = video.parents('.media').find('.video-control');
        control.removeClass("playing");
      });
    }



    if ($(".form form").length > 0) {
      $("body").on("click", ".form form .submit-box", function (e) {
        const $form = $(this).closest("form");
        if ($form.length) {
          $form.trigger("submit");
        }
      });
    }


    if ($("footer .footer-list").length > 0) {
      $("body").on("click", "footer .footer-list ul>li .list-title", function (e) {
        e.stopPropagation();

        if ($(window).width() > 1079.8) return;

        const me = $(this), li = me.parents("li");
        if (!li.hasClass("active")) {
          li.siblings("li").removeClass("active");
          li.siblings("li").find(".list-content").stop().slideUp(300);

          li.addClass("active");
          li.find(".list-content").stop().slideDown(300);
        } else {
          li.removeClass("active");
          li.find(".list-content").stop().slideUp(300);
        }
      });

      $(document).on("click", function (e) {
        if (!$(e.target).closest('footer .footer-list ul>li').length && $('footer .footer-list ul>li').hasClass('active')) {
          $('footer .footer-list ul>li').removeClass('active');
          $('footer .footer-list ul>li .list-content').stop().slideUp(300);
        }
      })
    }



    // accordion
    if ($(".accordion-box").length > 0) {
      $(".accordion-box .accordion-head").click(function (e) {
        e.preventDefault();
        let me = $(this),
          parent = me.parents(".accordion-item");
        if (!parent.hasClass("active")) {
          if (parent.parents(".product-info__sticky").length > 0) {
            me.parents(".product-info__sticky").find(".accordion-box .accordion-item").removeClass("active");
            me.parents(".product-info__sticky").find(".accordion-box .accordion-body").stop().slideUp(300);
            parent.addClass("active").find(".accordion-body").stop().slideDown(300);
          }

          me.siblings(".accordion-body").stop().slideDown(300);
          parent.addClass("active").siblings("").removeClass("active").find(".accordion-body").stop().slideUp(300);
        } else {
          parent.removeClass("active").find(".accordion-body").stop().slideUp(300);
        }
      });

      $(document).on("click", (e) => {
        if (!$(e.target).closest('.accordion-box .accordion-item').length && $('.accordion-box .accordion-item').hasClass('active')) {
          $('.accordion-box .accordion-item').removeClass('active').find('.accordion-body').stop().slideUp(300);
        }
      })


      const accordionBox = $(".cc-main-product .product-info__sticky .accordion-box").first();
      if (accordionBox.length > 0) {
        accordionBox.find(".accordion-item").addClass("active").find(".accordion-body").stop().slideDown(300);
      }
    }




    const targetSelector = ".cc-product-details .container .product-details__block";

    function updateMediaAndDetailsHeight() {
      const $target = $(targetSelector);
      if ($target.length > 0) {
        const height = $target.outerHeight();
        $("main").css({
          "--media-and-details-height": height + "px",
        });
      }
    }

    if ($(targetSelector).length > 0) {
      updateMediaAndDetailsHeight();

      const targetElement = document.querySelector(targetSelector);
      const observer = new MutationObserver(function (mutations) {
        updateMediaAndDetailsHeight();
      });

      const config = {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'style', 'height'],
        characterData: true
      };

      observer.observe(targetElement, config);

      $(window).on("resize", updateMediaAndDetailsHeight);
    }

  },

  appHeight: function () {
    const doc = document.documentElement;
    let height = window.visualViewport ? window.visualViewport.height : window.innerHeight;
    $('body').attr("style", "--height:" + height + "px");
    doc.style.setProperty('--vh', (jQuery(window).innerHeight() * .01) + 'px');


    // top banner
    if ($(".top-banner-new").length > 0) {
      const height = $(".top-banner-new").outerHeight();
      $("body").css({
        "--top-banner-new-height": height + "px",
      });
    }

    // header
    if ($("header").length > 0) {
      const height = $("header").outerHeight();
      $("body").css({
        "--header-height": height + "px",
      });
    }

    // 
    if ($(".block-service-benefits").length > 0) {
      const height = $(".block-service-benefits").outerHeight();
      $(".block-banner").css({
        "--service-benefits-height": height + "px",
      });
    }


    // 
    if ($(".block-collection-and-carousel").length > 0) {
      $(".block-collection-and-carousel").each(function () {
        const me = $(this), carouselBox = me.find(".collection-and-carousel .carousel-box-content");
        let num = Math.floor((carouselBox.width() - 12) / (352.45 + 12));
        me.find(".collection-and-carousel .carousel-box").css({
          "--card-max-num": num,
        });
      })
    }
  },


  slider: function () {
    if ($('.bestsellers-cards-box.swiper').length > 0) {
      $(".bestsellers-cards-box.swiper:not(.swiper-initialized)").each(function (index, element) {
        let swiperContainer = $(element);

        let swiperBtnPrev = $(element).parents("section").find(".swiper-btn-box .swiper-button-prev");
        let swiperBtnNext = $(element).parents("section").find(".swiper-btn-box .swiper-button-next");

        if (swiperContainer.length > 0) {
          let swiperInstance = new Swiper(swiperContainer[0], {
            slidesPerView: "auto",
            resistance: true,
            speed: 300,
            navigation: {
              prevEl: swiperBtnPrev[0],
              nextEl: swiperBtnNext[0],
            },
            mousewheel: {
              forceToAxis: true,
            },
          });
        }
      });
    }


    if ($('.mobile-bestsellers-cards-box.swiper').length > 0) {
      $(".mobile-bestsellers-cards-box.swiper:not(.swiper-initialized)").each(function (index, element) {
        let swiperContainer = $(element);

        let swiperBtnPrev = $(element).parents("section").find(".mobile-swiper-btn-box .swiper-button-prev");
        let swiperBtnNext = $(element).parents("section").find(".mobile-swiper-btn-box .swiper-button-next");

        if (swiperContainer.length > 0) {
          let swiperInstance = new Swiper(swiperContainer[0], {
            slidesPerView: "auto",
            resistance: true,
            speed: 300,
            autoHeight: true,
            navigation: {
              prevEl: swiperBtnPrev[0],
              nextEl: swiperBtnNext[0],
            },
          });
        }
      });
    }


    if ($('.mobile-category-grid-all-box.swiper').length > 0) {
      $(".mobile-category-grid-all-box.swiper").each(function (index, element) {
        let swiperContainer = $(element);

        let swiperBtnPrev = $(element).parents("section").find(".mobile-swiper-btn-box .swiper-button-prev");
        let swiperBtnNext = $(element).parents("section").find(".mobile-swiper-btn-box .swiper-button-next");

        if (swiperContainer.length > 0) {
          let swiperInstance = new Swiper(swiperContainer[0], {
            slidesPerView: "auto",
            resistance: true,
            speed: 300,
            autoHeight: true,
            navigation: {
              prevEl: swiperBtnPrev[0],
              nextEl: swiperBtnNext[0],
            },
          });
        }
      });
    }


    if ($('.block-testimonial-carousel').length > 0) {
      $(".block-testimonial-carousel").each(function (index, element) {
        let swiperContainer = $(element).find(".swiper");

        let swiperBtnPrev = $(element).find(".swiper-button-prev");
        let swiperBtnNext = $(element).find(".swiper-button-next");

        if (swiperContainer.length > 0) {
          let swiperInstance = new Swiper(swiperContainer[0], {
            slidesPerView: "auto",
            resistance: true,
            speed: 300,
            navigation: {
              prevEl: swiperBtnPrev[0],
              nextEl: swiperBtnNext[0],
            },
            mousewheel: {
              forceToAxis: true,
            },
          });
        }
      });
    }



    if ($('.block-blog-posts-list').length > 0) {

      function initBlogSwiper() {
        let $section = $('.block-blog-posts-list');
        if ($(window).width() <= 991.8) {
          $section.each(function (index, element) {
            let swiperContainer = $(element).find(".swiper");

            if (swiperContainer.length > 0 && !swiperContainer.data('swiper-initialized')) {
              let swiperInstance = new Swiper(swiperContainer[0], {
                slidesPerView: "auto",
                resistance: true,
                freeMode: true,
                scrollbar: {
                  el: '.swiper-scrollbar',
                },
              });

              if (swiperInstance.slides.length <= 1) {
                swiperInstance.destroy();
              } else {
                swiperContainer.data('swiper-initialized', true);
              }
            }
          });
        } else {
          $section.each(function (index, element) {
            let swiperContainer = $(element).find(".swiper");
            if (swiperContainer.length > 0) {
              let swiperInstance = swiperContainer.data('swiper');
              if (swiperInstance) {
                swiperInstance.destroy();
                swiperContainer.removeData('swiper-initialized');
              }
            }
          });
        }
      }

      initBlogSwiper();

      let resizeTimer;
      $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(initBlogSwiper, 100);
      });
    }



    if ($('.block-service-benefits-3').length > 0) {

      function initSwiper() {
        let $section = $('.block-service-benefits-3');
        if ($(window).width() <= 991.8) {
          $section.each(function (index, element) {
            let swiperContainer = $(element).find(".swiper");

            if (swiperContainer.length > 0 && !swiperContainer.data('swiper-initialized')) {
              let swiperInstance = new Swiper(swiperContainer[0], {
                slidesPerView: "auto",
                resistance: true,
                freeMode: true,
                scrollbar: {
                  el: '.swiper-scrollbar',
                },
              });

              if (swiperInstance.slides.length <= 1) {
                swiperInstance.destroy();
              } else {
                swiperContainer.data('swiper-initialized', true);
              }
            }
          });
        } else {
          $section.each(function (index, element) {
            let swiperContainer = $(element).find(".swiper");
            if (swiperContainer.length > 0) {
              let swiperInstance = swiperContainer.data('swiper');
              if (swiperInstance) {
                swiperInstance.destroy();
                swiperContainer.removeData('swiper-initialized');
              }
            }
          });
        }
      }

      initSwiper();

      let resizeTimer;
      $(window).on('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(initSwiper, 100);
      });
    }
  }

};


let $ = jQuery.noConflict();
$(document).ready(function () {
  let videos = $("section video:not([autoplay]:not([autoplay='false']))");

  if (videos.length > 0) {
    videos.each(function () {
      const video = $(this).get(0);

      video.load();

      video.addEventListener('loadedmetadata', () => {
        if (video.paused) {
          setTimeout(() => {
            video.play()
              .then(() => {
                video.pause();
                video.currentTime = 0;
              })
              .catch(err => {
                if (err.name === 'AbortError') {
                  console.log('Video playback was interrupted by the system. Try to set the current time directly:', err);
                  video.currentTime = 0;
                } else {
                  console.log('Autoplay blocked by browser:', err);
                }
              });
          }, 100);
        }
      });

      video.addEventListener('error', (err) => {
        console.log('Video loading error:', err);
      });
    });
  }

  morph.init();
});


$(window).on("scroll", function () {
  morph.wowo();
  morph.nav();
})


$(window).on("resize", function () {
  morph.appHeight();

})





